import { render } from "./CommonPageErrorMessage.vue?vue&type=template&id=4ec365fa"
import script from "./CommonPageErrorMessage.vue?vue&type=script&lang=js"
export * from "./CommonPageErrorMessage.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\projects\\gvnpro\\payroll-system\\dashboards\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__